<template>
  <div :class="wrpCls">
    <span class="login-info" v-show="showInfo.er_name">当前考场：{{ showInfo.er_name}}</span>
    <span class="login-info" v-show="showInfo.ed_name">当前考区：{{ showInfo.ed_name}}</span>
    <span class="login-info login-info-last" v-show="showInfo.ewd_name">当前候考室：{{ showInfo.ewd_name}}</span>
    <span class="large-screen-link"  v-show="showInfo.ed_name" @click="handleJump('/#/countdown')">倒计时大屏</span>
    <span class="large-screen-link large-screen-link-last "  v-show="showInfo.ewd_name" @click="handleJump('/#/waitingarea')">候考室大屏</span>
    <a-button type="primary" @click="backAdmin" v-show="simulate" ghost>
      <svg t="1735809761465" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
        p-id="1701" width="16" height="16" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path
          d="M558.811429 155.574857a73.142857 73.142857 0 0 1 9.386666 9.386667L707.047619 331.580952l153.161143-113.103238a73.142857 73.142857 0 0 1 114.419809 76.556191L828.952381 877.714286H195.047619L49.371429 295.058286A73.142857 73.142857 0 0 1 163.791238 218.453333L316.952381 331.580952l138.849524-166.619428a73.142857 73.142857 0 0 1 103.033905-9.386667zM512 211.772952l-183.003429 219.623619-208.65219-154.087619L252.14781 804.571429h519.70438l131.803429-527.262477-208.65219 154.087619L512 211.772952z m170.666667 457.874286v78.019048H341.333333v-78.019048h341.333334z"
          p-id="1702" fill="#1890FF"></path>
      </svg>
      返回超管权限
    </a-button>
    <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue'
import { mapGetters } from 'vuex'
import AvatarDropdown from './AvatarDropdown'
import SelectLang from '@/components/SelectLang'
import { simulateLogin } from '@/api/system/user'

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    SelectLang,
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action',
    },
    isMobile: {
      type: Boolean,
      default: () => false,
    },
    topMenu: {
      type: Boolean,
    },
    theme: {
      type: String,
    },
  },
  data() {
    return {
      showMenu: true,
      simulate: false,
      currentUser: {},
    }
  },

  computed: {
    wrpCls() {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${this.isMobile || !this.topMenu ? 'light' : this.theme}`]: true,
      }
    },
    showInfo() {
      try {
        return JSON.parse(localStorage.getItem('loginInfo')) || {};
      } catch (error) {
        return '数据错误';
      }
    },
    ...mapGetters(['nickname']),
  },
  mounted() {
    this.simulate = eval(localStorage.getItem('simulate'))
    setTimeout(() => {
      this.currentUser = {
        name: this.nickname,
      }
    }, 1500)
  },
  methods: {
    async backAdmin() {
      let that = this
      Modal.confirm({
        title: '提示',
        content: `确定返回超管权限吗？`,
        async onOk() {
          await simulateLogin({ user_id: 0 })
          localStorage.setItem('simulate', false)
          that.simulate = false
          window.location.reload()
        },
        onCancel() { },
      })
    },
    // 大屏跳转
    handleJump(path) {
      window.open(path, '_blank');
    }
  },
}
</script>
<style scoped>
.header-color-white {
  color: white;
}

svg {
  position: relative;
  top: 3px;
  right: 3px;
}

.login-info{
  padding: 0 10px;
  border-right: 2px solid #000000;
  font-weight: bold;
}

.login-info-last{
  margin-right: 30px;
  border-right:none;
}

.large-screen-link {
  margin-right: 30px;
  color: #1890ff;
  cursor: pointer;
}

.large-screen-link:hover {
  text-decoration: underline;
}

.large-screen-link-last {
  margin-right: 50px;
}
</style>
